import { render } from "./PreventionBoxInfo.component.vue?vue&type=template&id=179b3683"
import script from "./PreventionBoxInfo.component.vue?vue&type=script&lang=js"
export * from "./PreventionBoxInfo.component.vue?vue&type=script&lang=js"

import "./PreventionBoxInfo.component.vue?vue&type=style&index=0&id=179b3683&lang=scss"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/prevention/preventionBoxes/PreventionBoxInfo.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "179b3683"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('179b3683', __exports__)) {
    console.log('reload')
    api.reload('179b3683', __exports__)
  }
  
  module.hot.accept("./PreventionBoxInfo.component.vue?vue&type=template&id=179b3683", () => {
    console.log('re-render')
    api.rerender('179b3683', render)
  })

}


export default __exports__